const CompanyInfoGlobals = {
  bankAccountNumber: '12-3140-0347202-00',
  bankAccountName: 'Keyhook App',
};

export default CompanyInfoGlobals;
